import { useState, useEffect, useRef } from 'react';
import { getSplitDocForSite } from '../../api/splitDoc';
import { SPLIT_DOC_EDIT_MODES, SPLIT_DOC_PARAMETERS, SCRIPT_TYPES } from '../../core/constants';
import { getInitialSplitDocConfig } from '../../utilities/initialConfigs';
import { useNavigate } from 'react-router-dom';
import { getSiteConfig } from '../../api/sites';

const { SCRIPTS, TYPE, VALUE } = SPLIT_DOC_PARAMETERS;
const { SCRIPT, HTML } = SCRIPT_TYPES;

const useSplitDoc = (siteId, handlePageNavigation = false) => {
	const [splitDoc, setSplitDoc] = useState(null);
	const [splitDocEditMode, setSplitDocEditMode] = useState('');
	const previousSplitDoc = useRef({});
	const navigate = useNavigate();

	//TODO : This function can be combined in future with getSplitDocWithEncodedScripts, since it has common code lines
	const getSplitDocWithDecodedScripts = (splitDocConfig) => {
		const newSplitDoc = structuredClone(splitDocConfig);
		const scripts = newSplitDoc[SCRIPTS];
		if (!scripts) {
			return splitDocConfig;
		}
		const newScripts = {};
		Object.keys(scripts).forEach((scriptName) => {
			const scriptData = { ...scripts[scriptName] };
			if (scriptData[TYPE] === SCRIPT || scriptData[TYPE] === HTML) {
				scriptData[VALUE] = window.atob(scriptData[VALUE]);
			}
			newScripts[scriptName] = scriptData;
		});
		newSplitDoc[SCRIPTS] = newScripts;
		return newSplitDoc;
	};

	//TODO : This function can be combined in future with getSplitDocWithDecodedScripts, since it has common code lines
	const getSplitDocWithEncodedScripts = () => {
		if (!splitDoc) return {};
		const newSplitDoc = structuredClone(splitDoc);
		const scripts = newSplitDoc[SCRIPTS];
		if (!scripts) {
			return splitDoc;
		}
		const newScripts = {};
		Object.keys(scripts).forEach((scriptName) => {
			const scriptData = { ...scripts[scriptName] };
			if (scriptData[TYPE] === SCRIPT || scriptData[TYPE] === HTML) {
				scriptData[VALUE] = window.btoa(scriptData[VALUE]);
			}
			newScripts[scriptName] = scriptData;
		});
		newSplitDoc[SCRIPTS] = newScripts;
		return newSplitDoc;
	};

	useEffect(() => {
		(async function () {
			if (siteId && !splitDoc) {
				try {
					const { data } = await getSplitDocForSite(siteId);
					const splitDoc = data?.data?.splitDoc;
					const decodedSplitDoc = getSplitDocWithDecodedScripts(splitDoc);
					setSplitDoc(decodedSplitDoc);
					setSplitDocEditMode(SPLIT_DOC_EDIT_MODES.UPDATE);
					previousSplitDoc.current = splitDoc;
				} catch (err) {
					//TODO : Can check response code , if 404 only then change mode to create, else show something else in the ui for the error response
					console.log('Couldnt fetch hence mode must be CREATE');
					const { data } = await getSiteConfig(siteId);
					const instSiteDoc = structuredClone(data?.data?.site);
					const initialSplitDocConfig = getInitialSplitDocConfig(
						Number(instSiteDoc.siteId),
						instSiteDoc.siteDomain
					);
					setSplitDoc(initialSplitDocConfig);
					setSplitDocEditMode(SPLIT_DOC_EDIT_MODES.CREATE);
					if (handlePageNavigation) navigate(`/splitDoc/create-config/${siteId}`);
				}
			}
		})();
	}, [siteId, splitDoc]);

	return {
		splitDoc,
		updateSplitDoc: setSplitDoc,
		splitDocEditMode,
		updateSplitDocEditMode: setSplitDocEditMode,
		getSplitDocWithEncodedScripts,
		getSplitDocWithDecodedScripts,
		previousSplitDoc
	};
};

export default useSplitDoc;
